import { useNavigation } from "@react-navigation/native";
import { Text } from "@ui-kitten/components";
import Chip from "components/Chip";
import MainContainer from "components/MainContainer";
import { useAccount } from "hooks/useAccount";
import i18n from "plugins/localization";
import React, { useState } from "react";
import { Pressable, ScrollView, View } from "react-native";
import { RefreshControl } from "react-native-web-refresh-control";
import EventListItem from "./EventListItem";

export default function MyEvents() {
  const { accountEvents: events = [], fetchAccount } = useAccount();
  const [refreshing, setRefreshing] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState<string>("All");
  const navigation = useNavigation() as any;

  const onRefresh = async () => {
    setRefreshing(true);
    await fetchAccount();
    setRefreshing(false);
  };

  const availableEventTypes = [
    "All",
    ...new Set(events.map((event) => event.event.type)),
  ].sort((a, b) => a.localeCompare(b)); // sort by event type alphabetically

  const filteredEvents =
    selectedEventType === "All"
      ? events
      : events.filter((event) => event.event.type === selectedEventType);

  return (
    <MainContainer
      showLeftAction={false}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
    >
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingVertical: 10,
          paddingHorizontal: 10,
          gap: 10,
        }}
        style={{ flexGrow: 0 }}
      >
        {availableEventTypes.map((type) => (
          <Chip
            key={type}
            onPress={() => setSelectedEventType(type)}
            selected={selectedEventType === type}
            size="medium"
          >
            {type}
          </Chip>
        ))}
      </ScrollView>
      {filteredEvents.length === 0 && (
        <Text
          style={{
            color: "gray",
            textAlign: "center",
            fontWeight: "700",
            marginTop: 10,
            fontSize: 28,
          }}
        >
          {i18n.t("screens.MyEvents.noGamesYet")}
        </Text>
      )}
      <View style={{ paddingHorizontal: 15 }}>
        {filteredEvents.map((eventDetail) => {
          return (
            <Pressable
              key={eventDetail.groupCode.groupCode}
              onPress={() =>
                navigation.push("EventDetail", {
                  groupCode: eventDetail.groupCode.groupCode,
                })
              }
            >
              <EventListItem eventDetail={eventDetail} />
            </Pressable>
          );
        })}
      </View>
    </MainContainer>
  );
}
